import {
  ESTUDIOTURNOS_SUCCESS,
  ESTUDIOTURNOS_LOADING,
  ESTUDIOTURNOS_ERROR,
  ESTUDIOTURNOS_LOGOUT,
  ESTUDIOTURNOS_SETCIRCUITORESO,
  ESTUDIOTURNOS_SETCIRCUITOTOMO,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import estudioInitialState from "../initialStates/estudioTurnosInitialState";

const estudioTurnos = (state, { payload, type }) => {
  switch (type) {
    case ESTUDIOTURNOS_LOADING:
      return {
        ...state,
        estudioTurnos: {
          ...state.estudioTurnos,
          error: false,
          loading: true,
        },
      };
    case ESTUDIOTURNOS_SUCCESS:
      return {
        ...state,
        estudioTurnos: {
          ...state.estudioTurnos,
          loading: false,
          error: false,
          data: payload,
        },
      };

    case ESTUDIOTURNOS_SETCIRCUITORESO:
      return {
         ...state,
        estudioTurnos: {
          ...state.estudioTurnos,
          circuitoReso: payload,
        },
      };
    case ESTUDIOTURNOS_SETCIRCUITOTOMO:
        return {
           ...state,
          estudioTurnos: {
            ...state.estudioTurnos,
            circuitoTomo: payload,
          },
        };
    case ESTUDIOTURNOS_ERROR:
      return {
        ...state,
        estudioTurnos: {
          ...state.estudioTurnos,
          error: payload,
          loading: false,
        },
      };
    case ESTUDIOTURNOS_LOGOUT:
      return estudioInitialState;
    case RESET_PORTAL_CONTEXT:
      return estudioInitialState;
    default:
      return state;
  }
};

export default estudioTurnos;
